import { render, staticRenderFns } from "./assessmentIndex.vue?vue&type=template&id=1de0d690&scoped=true"
import script from "./assessmentIndex.vue?vue&type=script&lang=js"
export * from "./assessmentIndex.vue?vue&type=script&lang=js"
import style0 from "./assessmentIndex.vue?vue&type=style&index=0&id=1de0d690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de0d690",
  null
  
)

export default component.exports